import React from 'react'
import { RouteProps, useParams } from 'react-router-dom'

import PageTemplate from '../../../templates/Page'
import { usePageTemplateProps } from '../../../templates/Page/useProps'
import { useTracking } from '../../../tracking'

import * as content from './content'

type Locale = keyof typeof content

const LegalsPage: React.FC<RouteProps> = () => {
  const { locale } = useParams<{ locale: string }>()
  const templateProps = usePageTemplateProps()
  useTracking()

  const fallbackLocale: Locale = 'en'
  const currentLocale = (locale as Locale) in content ? (locale as Locale) : fallbackLocale
  const html = content[currentLocale]

  return <PageTemplate {...templateProps} html={html} />
}

export default LegalsPage
